import Icon from '../components/Icon.vue'

Icon.register({
  quran: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 358.4c0 9.6-3.2 16-9.6 19.2-3.2 12.8-3.2 57.6 0 73.6 6.4 6.4 9.6 12.8 9.6 19.2v16c0 16-12.8 25.6-25.6 25.6h-326.4c-54.4 0-96-41.6-96-96v-320c0-54.4 41.6-96 96-96h326.4c16 0 25.6 9.6 25.6 25.6v332.8zM301.1 145.8l-11.2 22.6-25 3.6c-2.7 0.4-3.8 3.7-1.8 5.6l18.1 17.6-4.3 24.9c-0.4 2.1 1.3 3.8 3.2 3.8 0.5 0 1-0.1 1.5-0.4l22.4-11.8 22.4 11.8c0.5 0.3 1 0.4 1.5 0.4 1.9 0 3.6-1.7 3.2-3.8l-4.3-24.9 18.1-17.6c1.9-1.9 0.9-5.2-1.8-5.6l-25-3.6-11.2-22.6c-0.6-1.2-1.8-1.8-2.9-1.8s-2.3 0.6-2.9 1.8zM243.2 76.8c-63.5 0-115.2 51.7-115.2 115.2 0 63.5 51.7 115.2 115.2 115.2 13.6 0 27.1-2.5 40.2-7.3 2.7-0.9 4.6-3.4 4.6-6.4 0-3.6-2.9-6.8-6.8-6.8-0.7 0-3.1 0.2-4.1 0.2-52.3 0-94.9-42.6-94.9-94.9 0-52.3 42.5-94.9 94.9-94.9 1 0 3.5 0.2 4.1 0.2 0.6 0.2 1.7 0.4 2.4 0.4 3.7 0 6.8-3 6.8-6.8 0-3.7-3-6.8-6.8-6.8-13.1-4.9-26.7-7.4-40.4-7.4zM380.8 448v-64h-284.8c-16 0-32 12.8-32 32s12.8 32 32 32h284.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/quran.js
// module id = 1620
// module chunks = 0